import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

import { dataTableLinkClass } from './styles'

import { cn } from '@/lib/utils'

// mbscan manager-client の同名部品と共通。片側だけで変えない
// 使い方のルール: docs/develop/client_ui/components/data-table.md

export const DataTableAnchor = forwardRef<HTMLAnchorElement, ComponentPropsWithoutRef<'a'>>(function AnchorBase(
  { className, ...props },
  ref,
) {
  return <a ref={ref} className={cn(dataTableLinkClass, className)} {...props} />
})

// 詳細がドロワー・ダイアログ・インライン展開など、URL 遷移ではない場合に使う。見た目は DataTableAnchor と同じ
export const DataTableLinkButton = forwardRef<HTMLButtonElement, Omit<ComponentPropsWithoutRef<'button'>, 'type'>>(
  function DataTableLinkButton({ className, ...props }, ref) {
    return <button ref={ref} type="button" className={cn(dataTableLinkClass, 'text-left', className)} {...props} />
  },
)
